import {QueryCommand,AssertUtils,GoingUtils,TreeUtils} from "goingutils";
import  dhtmlXTreeObject from './dhtmlXTreeObject';


/**
 * 树重新加载数据
 * @param sleNode 是否选中当前节点
 * @param data 根据用户指定的js数组来初始化树
 * @param backFun 加载数据后的回调函数
 * @param selParent 是否选中父节点 一般用于删除操作
 */
dhtmlXTreeObject.prototype.reloadData = function ({
                                                      sleNode,
                                                      data,
                                                      backFun,
                                                      selParent = false
                                                  }) {
    let orgTreeObj = this;
    let nodeId = null;
    //如果selNode为true 则获取当前节点id
    if (sleNode) {
        nodeId = this.getSelectedItemId();
    }
    //如果父节点选中为true 则获取父节点id
    if (selParent && AssertUtils.isNotEmpty(nodeId)) {
        nodeId = this.getParentId(this.getSelectedItemId());
    }
    if (orgTreeObj != null) {
        //清空所有数据，重新刷新数据
        if(orgTreeObj.rootNodes!=null&&orgTreeObj.rootNodes.forEach){
            orgTreeObj.rootNodes.forEach((itemObj)=>{
                orgTreeObj.deleteChildItems(itemObj.id);
            });
        }
        orgTreeObj.deleteChildItems(0);
        //如果是传入的数据
        if (AssertUtils.isNotNull(data) && data.length > 0) {
            orgTreeObj.flushTreeByData(data, "jsarray");
            return void 0;
        }

        //如果传入了queryUrl 则直接查询加载data数据
        if (orgTreeObj.queryUrl.length > 0) {
            orgTreeObj.flushTreeByUrl({
                url: orgTreeObj.queryUrl,
                treeLoadData: orgTreeObj.treeLoadData,
                sleNodeFlag: sleNode,
                nodeId: nodeId,
                backFun
            });
        }
    }
};
//打开顶层节点
dhtmlXTreeObject.prototype.openRootNode = function () {
    let orgTreeObj=this;
    console.log(orgTreeObj.rootNodes,'----openRootNode-')
    if(orgTreeObj.rootNodes!=null&&orgTreeObj.rootNodes.forEach){
        orgTreeObj.rootNodes.forEach((itemObj)=>{
            orgTreeObj.openItem(itemObj.id);
        });
    }
    orgTreeObj.openItem(0);
};
//打开所有节点
dhtmlXTreeObject.prototype.openAllNode = function () {
    let orgTreeObj=this;
    if(orgTreeObj.rootNodes!=null&&orgTreeObj.rootNodes.forEach){
        orgTreeObj.rootNodes.forEach((itemObj)=>{
            orgTreeObj.openAllItems(itemObj.id);
        });
    }
    orgTreeObj.openAllItems(0);
};
//将打勾的节点都取消
dhtmlXTreeObject.prototype.unCheckAllNode = function (ids) {
    if (!AssertUtils.isArray(ids)) {
        ids = ids.split(";");
    }
    var treeObj = this;
    ids.forEach(function (item) {
        treeObj.setCheck(item, false);
    });
};

//通过data来初始化树对象
dhtmlXTreeObject.prototype.flushTreeByData = function (data) {
    this.data = data;
    this.parse(data, "jsarray");
    this.openItem("rootNode");
};
//清空所有节点
dhtmlXTreeObject.prototype.clearAll= function () {
    let orgTreeObj=this;
    //清空所有数据，重新刷新数据
    if(orgTreeObj.rootNodes!=null&&orgTreeObj.rootNodes.forEach){
        orgTreeObj.rootNodes.forEach((itemObj)=>{
            orgTreeObj.deleteChildItems(itemObj.id);
            orgTreeObj.deleteItem(itemObj.id);
        });
    }
    orgTreeObj.deleteChildItems(0);
    orgTreeObj.deleteItem(0);
};

/**
 * 根据用户定义的查询url 来加载数据
 * @param url 查询url地址
 * @param treeLoadData 加载的数据
 * @param sleNodeFlag 是否选中当前选中的记录
 * @param nodeId 如果传入了nodeid 则根据传入的id来选中节点
 * @param backFun 回调函数
 */
dhtmlXTreeObject.prototype.flushTreeByUrl = function ({
                                                          url,
                                                          treeLoadData,
                                                          sleNodeFlag,
                                                          nodeId = null,
                                                          backFun, params = {},
                                                            options={}
                                                      }) {
    //如果选中标志为true 则获取树当前选择的结点id
    let oldSelId = "";
    if (sleNodeFlag) {
        oldSelId = this.getSelectedItemId();
    }
    //如果节点id不为空 则根据节点id来选中节点
    if (AssertUtils.isNotEmpty(nodeId)) {
        oldSelId = nodeId;
        sleNodeFlag = true;
    }
    //如果传入的sleNodeFlag为字符串 则表示用户传入了节点id
    if (typeof sleNodeFlag === "string") {
        oldSelId = sleNodeFlag;
        sleNodeFlag = true;
    }

    let orgTreeObj = this;
    orgTreeObj.clearAll();


    orgTreeObj.queryUrl = url;
    orgTreeObj.treeLoadData = treeLoadData;
    let queryCommand = new QueryCommand({url});
    //查询数据 如果定义了数据转换函数 则通过转换函数来转换数据
    queryCommand.executeQuery({params,successFun:(backData)=> {
        if (AssertUtils.isNotNull(backData) && backData !== "") {
            //如果是分页查询获取的数据  则需要从list中获取
            if(backData["list"]!=null&&backData["list"].length>0){
                backData=backData["list"];
            }

            if(backData["data"]!=null){
                backData=backData["data"];
            }
            if (AssertUtils.isFunction(treeLoadData)) {
            //将结果返回成 树要求的格式
                orgTreeObj.parse(treeLoadData(backData), "jsarray");
            } else {
                backData = TreeUtils.getTreeData(backData, options);
                orgTreeObj.parse(backData, "jsarray");
            }
            // //获取起来所有顶层节点信息
            // orgTreeObj.rootNodes=TreeUtils.rootNode;
            // TreeUtils.rootNode.forEach((nodeItem)=>{
            //     //打开树节点信息
            //     orgTreeObj.openItem(nodeItem["id"]);
            // });


            if (sleNodeFlag && AssertUtils.isNotEmpty(oldSelId)) {
                orgTreeObj.selectItem(oldSelId, true, true);
                orgTreeObj.openItem(oldSelId);
            }
        //如果定义了回调函数 则执行回调
            if (backFun != null && AssertUtils.isFunction(backFun)) {
                backFun(orgTreeObj, backData);
                backData=null;
            }}
    }});
};

//树控件添加刷新图标
dhtmlXTreeObject.prototype.addTreeFlushImg = function (
    mainLayOut,
    cellName,
    fun
) {
    var ind = 0;
    let index = 0;
    //获取当前的cell的位置
    mainLayOut.forEachItem(function (cell) {
        if (cell.getId() == cellName) {
            ind = index;
        }
        index++;
    });
    //树刷新图片以及事件
    let treeId = GoingUtils.getUUid(12);
    $(
        '<div class="go-tree-flush-img" id="' +
        treeId +
        '"><i class="fas fa-sync"></i></div>'
    ).appendTo($($(".dhx_cell_hdr_text").get(ind)));
    $(".dhx_cell_hdr_text:eq(" + ind + ")")
        .next()
        .hide();
    $("#" + treeId).click(function () {
        fun();
    });

    //注册展开事件
    mainLayOut.attachEvent("onExpand", function (itemId) {
        if (cellName == itemId) {
            $(
                '<div class="go-tree-flush-img" id="' +
                treeId +
                '"><i class="fas fa-sync"></i></div>'
            ).appendTo($($(".dhx_cell_hdr_text").get(ind)));
            $("#" + treeId).click(function () {
                fun();
            });
        }
    });
    //注册关闭事件
    mainLayOut.attachEvent("onCollapse", function (itemId) {
        if (cellName == itemId) {
            $("#" + treeId).unbind();
            $("#" + treeId).remove();
        }
    });
};

//根据labels来设置checkbox的状态
dhtmlXTreeObject.prototype.checkBoxByLabels = function (labels) {
    let nameArys=[];
    if(AssertUtils.isArray(labels)){
        nameArys=labels;
    }else{
        nameArys=labels.split(GoingUtils.relChart);
    }
    nameArys.forEach((nodeName)=>{
        if(AssertUtils.isNotEmpty(nodeName)){
            let nodeId=this.findItemIdByLabel(nodeName);
            nodeId&&this.setCheck(nodeId,true);
        }
    });
};
//树查询bar
dhtmlXTreeObject.prototype.addSearchBar = function (cellObj) {
    let orgTreeObj = this;
    let toolBar = cellObj.attachToolbar();
    let operatorId = GoingUtils.getUUid(12);
    toolBar.addText(GoingUtils.getUUid(12), 0, `<div id="${operatorId}"></div>`);
    $("#" + operatorId)
        .closest(".dhx_toolbar_material")
        .removeClass("dhx_toolbar_material")
        .removeClass("dhxtoolbar_icons_18")
        .removeClass("dhx_toolbar_shadow");
    $("#" + operatorId)
        .parent()
        .addClass("go-tree-ctl");
    $("#" + operatorId).parent()
        .html(`<div class="search-div"><div class="input-icon right account-sel-div">
                <input id="${operatorId}_input" AUTOCOMPLETE="off" type="text" placeholder="输入查询值" class="form-control">
                <div id="${operatorId}_btn" class="search-btn"><i class="icon-search"></i></div></div></div>`);

    //点击查询按钮
    $(`#${operatorId}_btn`).click(function () {
        let searchVal = $(`#${operatorId}_input`).val();
        orgTreeObj.findItem(searchVal);
    });
};




// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dxTreeExtend.js